var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OptionalValidationWrapper',{attrs:{"clickPrevent":false,"errorStyleExceptions":_vm.$style.hideErrors,"label":_vm.label,"tooltip":_vm.tooltip}},[_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }